<template lang="pug">
  y-dialog(v-model="showModal" fill-height fluid scrollable persistent :fullscreen="$vuetify.breakpoint.xsOnly" transition="fade-transition" max-width="600px")
    v-card
      v-card-title.pa-0
        v-row.px-5.pt-3.pb-2(v-if="hasChanges" no-gutters align="center" :style="`background-color: ${$vuetify.theme.themes[$theme].success600}`")
          v-col.shrink
            v-btn.ml-n3(text icon @click="showModal = !showModal" height)
              eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].basic100" width="24" height="24")
          v-col.ml-3
            p.mb-0.h6.basic100--text {{ $t('save_changes') }}
          v-col.ml-3.shrink
            v-layout
              v-btn.mr-2.my-auto(depressed small outlined color="basic100" @click="clickRevert()")
                .button-AA-small.basic100--text {{ $t('cancel') }}
              v-btn.my-auto.basic100(depressed small @click="clickSave()" :loading="isLoading")
                .button-AA-small.primary500--text {{ $t('save') }}
        v-row.px-5.pt-3.pb-2(v-else no-gutters align="center")
          v-col.shrink
            v-btn.ml-n3(text icon @click="showModal = !showModal" height)
              eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].primary" width="24" height="24")
          v-col.ml-3
            p.mb-0.h6.basic800--text {{ $t('shipping_zones') }}

      v-card-text.pa-0
        v-container.pa-5
          div.h5.primary--text {{ $t('which_shipping_zones') }}
          div.p1.primary--text.mt-4 {{ $t('select_zone_appear_checkout') }}
          form-zones-shipping.my-6(:company="company" :form="parentForm" :szones="zones" :excludedZones.sync="form.excluded_zones" :parentOrderSettings.sync="orderSettings")

</template>

<script>
import { mapActions } from 'vuex'
import FormZonesShipping from '@/components/FormZonesShipping.vue'

export default {
  name: 'EditLandingShippingZones',
  props: ['open', 'parentForm', 'zones', 'company'],
  components: { FormZonesShipping },
  data: () => ({
    isLoading: false,
    form: {},
    original: {},
    orderSettings: null,
    originalOrderSettings: null,
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    hasChanges () {
      if (JSON.stringify(this.original) === JSON.stringify(this.form) && JSON.stringify(this.originalOrderSettings) === JSON.stringify(this.orderSettings)) {
        return false
      }
      return true
    }
  },
  mounted () {
    this.fetchOrderSettings()
    this.form = JSON.parse(JSON.stringify(this.parentForm))
    this.original = JSON.parse(JSON.stringify(this.parentForm))
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchOrderSettings () {
      this.$axios.get(`/oms/${this.company.slug}/`)
        .then((response) => {
          this.orderSettings = response.data
          this.originalOrderSettings = JSON.parse(JSON.stringify(response.data))
        })
        .catch(() => {})
    },
    clickRevert () {
      this.form = JSON.parse(JSON.stringify(this.original))
      this.orderSettings = JSON.parse(JSON.stringify(this.originalOrderSettings))
    },
    clickSave () {
      this.isLoading = true
      let data = { excluded_zones: this.form.excluded_zones }
      this.$axios.patch(`/forms/${this.parentForm.id}`, data)
        .then(resp => {
          if (this.orderSettings) {
            this.$axios.patch(`/oms/${this.company.slug}/`, { excluded_forms: this.orderSettings.excluded_forms })
              .catch(() => {
                this.showMessage(['error', this.$t('error_message.unable_to_update_order')])
              })
          }
          this.$emit('update:parentForm', resp.data)
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "shipping_zones": "Shipping zones",
    "which_shipping_zones": "Which shipping zones apply to this sales page?",
    "select_zone_appear_checkout": "Select which zone options will appear at customer checkout."
  },
  "id": {
    "shipping_zones": "Zona Penngiriman",
    "which_shipping_zones": "Zona pengiriman mana yang berlaku untuk halaman penjualan ini?",
    "select_zone_appear_checkout": "Pilih opsi zona mana yang akan muncul di checkout pelanggan."
  }
}
</i18n>